import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { setAuthToken, clearAllAuthCookies } from "../utils/cookieUtils";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    clearAllAuthCookies();
    // Clear any session flags from previous sessions
    sessionStorage.removeItem('natural_logout');
    localStorage.removeItem('session_conflict_handled');
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post("/super-admin/login", {
        email,
        password,
      });

      if (response.data.type === "success") {
        const token = response.data.message.token;
        setAuthToken(token);
        // Clear any logout flags since this is a fresh login
        sessionStorage.removeItem('natural_logout');
        localStorage.removeItem('session_conflict_handled');
        navigate("/dashboard");
        setEmail("");
        setPassword("");
      } else {
        toast.error("Invalid email or password");
      }
    } catch (error) {
      console.error("There was a problem with the login request:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to login. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="login-input">
        <div className="login-input-main container">
          <h1>Welcome back</h1>
          <p>Please enter your details</p>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <b>
                <label htmlFor="email">Email</label>
              </b>
              <br />
              <input
                type="email"
                id="email"
                aria-label="Email address"
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
                disabled={loading}
                autoComplete="email"
              />
            </div>
            <br />
            <div className="form-group">
              <b>
                <label htmlFor="password">Password</label>
              </b>
              <br />
              <input
                type="password"
                id="password"
                aria-label="Password"
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
                disabled={loading}
                autoComplete="new-password"
                autoFill="off"
                data-lpignore="true"
                spellCheck="false"
              />
              <br />
              <Link to="/request-otp" className="forgot-password">
                Forgot password?
              </Link>
            </div>
            <br />
            <button type="submit" className="signin-button" disabled={loading}>
              {loading ? <div className="login-spinner"></div> : "Sign In"}
            </button>
          </form>
        </div>
      </div>

      <div className="login-image1"></div>
    </div>
  );
}

export default Login;
